module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "list"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#list"
    }
  }, [_vm._v("List of Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "Fig-l1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#fig1",
      "id": "fig-1"
    }
  }, [_vm._v("Figure 1")]), _vm._v(". The SEKAP Spectrum of Christian-Muslim Interaction")]), _vm._v(" "), _c('p', {
    staticClass: "Fig-l"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#fig2",
      "id": "fig-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 2")]), _vm._v(". The Hermeneutical Emergence and Development of Islamic Jurisprudence ("), _c('i', [_vm._v("Fiqh")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "Fig-l"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#fig3",
      "id": "fig-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3")]), _vm._v(". The Hermeneutical Emergence and Development of Christian Thought and Praxis")]), _vm._v(" "), _c('p', {
    staticClass: "Fig-l"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#fig4",
      "id": "fig-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4")]), _vm._v(". Interpretation and Misinterpretation")]), _vm._v(" "), _c('p', {
    staticClass: "Fig-l"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#fig5",
      "id": "fig-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5")]), _vm._v(". Mecca and Medina")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36568726","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter002.vue
// module id = 72
// module chunks = 0